import React from "react";
import Chart from "react-google-charts";
import {CircularProgress} from "@material-ui/core";
import {FlagComponent} from "../countryFlag/flag";

export const CountryStatisticsSidebarComponent = (props) => {
    let hasManufacturers = props.manufacturers != null && props.manufacturers.length > 1
    return (
        <div className="ibox">
            <div className="ibox-content">
                <h3>
                    <FlagComponent imageName={props.image}/>
                    <span className={'pl-2'}> {props.country} statistical analysis</span>
                </h3>
                <h1 className="no-margins">{props.drugsCount}</h1>
                <small>Total drugs</small>
                <table className="table table-stripped small m-t-md">
                    <tbody>
                    <tr>
                        <td>
                            <i className="fa fa-circle text-navy"/>
                        </td>
                        <td className={'font-weight-bold'}>
                            {
                                hasManufacturers
                                ? <span> {props.numberOfManufacturers} total manufacturers</span>
                                : 'N/A'
                            }

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <i className="fa fa-circle text-navy"/>
                        </td>
                        <td className={'font-weight-bold'}>
                            Top manufacturer: {hasManufacturers ? props.manufacturers[1][0].toUpperCase() : 'N/A'}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <h4>Top manufacturers</h4>
                <div style={{minHeight: 182 + 'px'}} className="p-0">
                    {
                        hasManufacturers
                            ? <Chart
                                height={182}
                                chartType="PieChart"
                                loader={<div style={{minHeight: "100%"}} className={'d-flex align-items-center justify-content-center'}><CircularProgress/></div>}
                                data={props.manufacturers}
                                options={{
                                    legend: 'right',
                                    pieHole: 0.2,
                                    sliceVisibilityThreshold: 0.009, // 20%
                                }}
                            />
                            : <div style={{minHeight: props.height}} className={'m-auto'}>
                                <h3>No data available</h3>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
